import { defaultChoicePickerState } from 'shell/components/shared/choice-date/constants';
import { FiltersFormPerson, SearchPerson } from 'shell/view-models/search-anpr';

export const transformSearchPersonDataset = (
  values: FiltersFormPerson,
  isAire?: boolean
): SearchPerson => {
  const { subjectData, identityCard = {}, residencePermit = {}, searchByFiscalCode } = values;

  const birthdayChoice = subjectData?.birthdayChoice || defaultChoicePickerState;

  const hasMunicipalityFiltersItalian =
    !!subjectData?.municipalityOfBirth?.id ||
    !!subjectData?.provinceOfBirth ||
    !!subjectData?.locality;

  const hasMunicipalityFiltersForeign =
    !!subjectData?.foreignMunicipality?.id || !!subjectData?.foreignStateBirth;

  const hasSubjectIdMunicipality = !!subjectData?.municipalityId || !!subjectData?.istatCode;

  const hasSearchBirthPlaceFilters =
    hasMunicipalityFiltersItalian ||
    hasMunicipalityFiltersForeign ||
    !!subjectData?.exceptionalBirthplace;

  const hasSearchBirthFilters =
    hasSearchBirthPlaceFilters || (!!subjectData?.birthdayChoice && !!subjectData?.birthday);

  const hasMunicipalityIdentityCard = !!identityCard?.municipality?.id || !!identityCard.province;

  const hasSearchIdentityCard =
    hasMunicipalityIdentityCard || !!identityCard.consulate || !!identityCard.number;

  const hasSearchPermitReferences = !!residencePermit.permitNumber || !!residencePermit.preccint;

  const hasSearchResidencePermit = hasSearchPermitReferences || !!residencePermit.passportNumber;

  const hasSearchCriteria =
    !!subjectData?.gender ||
    !!searchByFiscalCode?.fiscalCode ||
    !!subjectData?.fiscalCode ||
    !!subjectData?.name ||
    !!subjectData?.surname ||
    !!subjectData?.withoutName ||
    !!subjectData?.withoutSurname ||
    !!subjectData?.anprId;

  const transformedFilters: SearchPerson = {
    criteriRicerca:
      hasSubjectIdMunicipality ||
      hasSearchResidencePermit ||
      hasSearchCriteria ||
      hasSearchIdentityCard
        ? {
            sesso: subjectData?.gender || undefined,
            soggettoAIRE: isAire ? 'S' : undefined,
            codiceFiscale: searchByFiscalCode?.fiscalCode || subjectData?.fiscalCode || undefined,
            nome: subjectData?.name || undefined,
            cognome: subjectData?.surname || undefined,
            senzaNome: subjectData?.withoutName ? '1' : undefined,
            senzaCognome: subjectData?.withoutSurname ? '1' : undefined,
            idSchedaSoggettoANPR: subjectData?.anprId || undefined,
            idSchedaSoggettoComune: hasSubjectIdMunicipality
              ? {
                  idSchedaSoggetto: subjectData?.municipalityId || undefined,
                  idSchedaSoggettoComuneIstat: subjectData?.istatCode || undefined,
                }
              : undefined,
            permessoDiSoggiorno3000: hasSearchResidencePermit
              ? {
                  datiSoggiorno30XX: hasSearchPermitReferences
                    ? {
                        numeroSoggiorno: residencePermit.permitNumber || undefined,
                        questuraRilascioSoggiorno: residencePermit.preccint || undefined,
                      }
                    : undefined,
                  numeroPassaporto: residencePermit.passportNumber || undefined,
                }
              : undefined,
            cartaIdentita3000: hasSearchIdentityCard
              ? {
                  comuneRilascio: hasMunicipalityIdentityCard
                    ? {
                        codiceIstat: identityCard.municipality?.id || undefined,
                        siglaProvinciaIstat: identityCard.municipality?.province || undefined,
                        nomeComune: identityCard.municipality?.description || undefined,
                      }
                    : undefined,
                  codiceConsolatoRilascio: identityCard.consulate || undefined,
                  numero: identityCard.number || undefined,
                }
              : undefined,
          }
        : undefined,
    datiNascita: hasSearchBirthFilters
      ? {
          senzaGiorno:
            !birthdayChoice?.includes('day') && birthdayChoice?.includes('month') ? '1' : undefined,
          senzaGiornoMese:
            !birthdayChoice?.includes('day') &&
            !birthdayChoice?.includes('month') &&
            subjectData?.birthday
              ? '1'
              : undefined,
          dataEvento:
            subjectData?.birthday && subjectData?.birthday?.isValid
              ? subjectData?.birthday.toFormat('yyyy-MM-dd')
              : undefined,
          luogoNascita: hasSearchBirthPlaceFilters
            ? {
                comune: hasMunicipalityFiltersItalian
                  ? {
                      codiceIstat: subjectData?.municipalityOfBirth?.id || undefined,
                      siglaProvinciaIstat: subjectData?.municipalityOfBirth?.province || undefined,
                      nomeComune: subjectData?.municipalityOfBirth?.description || undefined,
                      descrizioneLocalita: subjectData?.locality || undefined,
                    }
                  : undefined,
                localita: hasMunicipalityFiltersForeign
                  ? {
                      codiceStato: subjectData?.foreignStateBirth?.id || undefined,
                      descrizioneStato: subjectData?.foreignStateBirth?.value || undefined,
                      provinciaContea: subjectData?.foreignMunicipality?.province || undefined,
                    }
                  : undefined,
                luogoEccezionale: subjectData?.exceptionalBirthplace || undefined,
              }
            : undefined,
        }
      : undefined,
    datiRichiesta: {
      dataRiferimentoRichiesta: subjectData?.referenceDate?.toFormat('yyyy-MM-dd') || undefined,
      comuneResidenza:
        values?.commonSearch?.provinceOfResidence ||
        values?.commonSearch?.municipalityOfResidence?.id ||
        subjectData?.provinceOfResidence ||
        subjectData?.municipalityOfResidence?.id
          ? {
              siglaProvinciaIstat:
                values?.commonSearch?.municipalityOfResidence?.province ||
                subjectData?.municipalityOfResidence?.province ||
                undefined,
              codiceIstat:
                values?.commonSearch?.municipalityOfResidence?.id ||
                subjectData?.municipalityOfResidence?.id ||
                undefined,
              nomeComune:
                values?.commonSearch?.municipalityOfResidence?.description ||
                subjectData?.municipalityOfResidence?.description ||
                undefined,
            }
          : undefined,
      ricercaNazionale:
        values?.commonSearch?.isNationalResearch || subjectData?.isNationalResearch ? '1' : '0',
    },
  };

  return transformedFilters;
};
